var path = '/static/assets/khapps2/base/khutils/partials/kh_tabs.html';
var html = "<md-tabs md-dynamic-height flex>\n    <md-tab label=\"{{ tab.kh_tab_title }}\" ng-repeat=\"tab in tabdetails\">\n        <div ng-include=\"tab.kh_tab_templateUrl\"></div>\n    </md-tab>\n</md-tabs>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;